<template>
  <div class="live d-flex align-items-center" style="z-index:9999999999999999">
    <div
      class="d-flex px-2 align-items-center text_bg h-100 bg-dark text-white"
    >
      LIVE
      <br />MARKET PRICES
    </div>
    <infinite-slide-bar duration="80s" class="content">
      <div class="d-flex align-items-center h-100">
        <div class="item px-1 px-md-0">
          <h6>Soyabeans</h6>
          <small>
            N120,000
            <span class="text-success">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-up']"
              class="ml-1 text-success"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Sorghum</h6>
          <small>
            N83,000
            <span class="text-blue">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-right']"
              class="ml-1 text-blue"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Ginger</h6>
          <small>
            N83,000
            <span class="text-success">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-up']"
              class="ml-1 text-success"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Cocoa</h6>
          <small>
            N69,000
            <span class="text-danger">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-down']"
              class="ml-1 text-danger"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Soyabeans</h6>
          <small>
            N120,000
            <span class="text-success">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-up']"
              class="ml-1 text-success"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6 class="mb-0 text-black">Cocoa</h6>
          <small>
            N69,000
            <span class="text-blue">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-right']"
              class="ml-1 text-blue"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Sorghum</h6>
          <small>
            N83,000
            <span class="text-success">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-up']"
              class="ml-1 text-success"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Cocoa</h6>
          <small>
            N69,000
            <span class="text-danger">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-down']"
              class="ml-1 text-danger"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6>Ginger</h6>
          <small>
            N83,000
            <span class="text-success">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-up']"
              class="ml-1 text-success"
            />
          </small>
        </div>
        <div class="item px-2 px-lg-0">
          <h6 class="mb-0 text-black">Cocoa</h6>
          <small>
            N69,000
            <span class="text-blue">0.00%</span>
            <font-awesome-icon
              :icon="['fas', 'arrow-right']"
              class="ml-1 text-blue"
            />
          </small>
        </div>
      </div>
    </infinite-slide-bar>
  </div>
</template>

<script>
import InfiniteSlideBar from "vue-infinite-slide-bar";
export default {
  components: {
    InfiniteSlideBar
  },

  mounted() {
    let footer = document.querySelector("footer");
    footer && footer.classList.add("has_market_price");
  },

  destroyed() {
    let footer = document.querySelector("footer");
    footer && footer.classList.remove("has_market_price");
  }
};
</script>

<style scoped>
.live {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  border-top: 1px solid black;
  background-color: #f5f5f5;
}
.text-blue {
  color: #0000ff;
}

.content {
  flex: 1;
}

.text_bg {
  min-width: 132px;
  flex: 0 1 120px;
}

.item {
  width: auto;
  flex-grow: 1;
  margin: 0;
}

.item > h6 {
  margin-bottom: 0 !important;
  color: #000;
}

.item span {
  display: inline-block;
  margin-left: 1px;
}
</style>
